import React, { useCallback, useMemo } from 'react';
import { useBookingNavbar } from 'Components/widgets/booking-navbar/useBookingNavbar';
import { useFormikContext } from 'formik';
import { isEmpty } from 'lodash';
import { PAYPAL_PSP_ID } from 'Components/widgets/payment-info/PaymentInfo.const';
import { useAppContext } from 'Context/ReactAppContext';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
import { PaypalForm } from './PaypalForm';

export const usePaypalForm = () => {
  const formik = useFormikContext();
  const appContext = useAppContext();
  const { paymentProviderId, amountToPay } = formik.values;

  const isAbleToPay =
    isFeatureFlipped(appContext)('psp.paypal.enable_button') &&
    paymentProviderId === PAYPAL_PSP_ID &&
    isEmpty(formik.errors?.termsAndConditions);

  const onSuccess = useCallback(
    (token) => {
      formik.setFieldValue('token', token);
      formik.submitForm();
    },
    [formik],
  );

  const onError = useCallback(() => {
    formik.setFieldValue('token', '');
  }, [formik]);

  const paypalButton = useMemo(() => {
    if (!isAbleToPay) {
      return null;
    }

    return (
      <PaypalForm
        isAbleToPay={isAbleToPay}
        onSuccess={onSuccess}
        amount={amountToPay}
        onError={onError}
      />
    );
  }, [isAbleToPay, onSuccess, amountToPay, onError]);

  useBookingNavbar({
    continueBtn: paypalButton,
  });
};
